// routes.tsx
import { HiUsers } from "react-icons/hi";
import { AiOutlineHome, AiOutlineBuild  } from "react-icons/ai";
import { Route } from './sideBarMenu';

const routes: Route[] = [
    {
        path: "/home",
        name: "Home",
        icon: <AiOutlineHome style={{ height: 20, width: 20 }} />,
    },
    {
        path: "/users",
        name: "Manage Users",
        icon: <HiUsers style={{ height: 20, width: 20 }} />,
    },
    {
        path: "/company",
        name: "Manage Company",
        icon: <AiOutlineBuild  style={{ height: 20, width: 20 }} />,
    },
    {
        path: "/roles",
        name: "Manage Roles",
        icon: <AiOutlineBuild  style={{ height: 20, width: 20 }} />,
    },
];

export default routes;
